/**
 * Named colors (ex. White, Blue etc...)
 */
export const COLOR_BLACK = '#000000'
export const COLOR_DARK = '#27272E'
export const COLOR_GREY_050 = '#F7FAFC'
export const COLOR_GRAY__070 = '#9C9C9C'
export const COLOR_GRAY_LIGHT = '#425466'
export const COLOR_GRAY__100 = '#EDF2F7'
export const COLOR_GRAY__200 = '#EDF2F9'
export const COLOR_GRAY__300 = '#CBD5E0'
export const COLOR_GRAY__400 = '#B0B7C3'
export const COLOR_GRAY__500 = '#A0AEC0'
export const COLOR_GRAY__600 = '#718096'
export const COLOR_GRAY__800 = '#2D3748'
export const COLOR_GREEN__DARK = '#B9AA00'
export const COLOR_GREEN__LIGHT = '#d6ce72'
export const COLOR_GREEN__100 = 'rgba(185, 170, 0, 0.1)'
export const COLOR_GREEN__PALE = '#87AF7A'
export const COLOR_TURQUOISE = '#00A6CD'
export const COLOR_TURQUOISE__LIGHT = '#61C4CE'
export const COLOR_WHITE = '#FFFFFF'
export const COLOR_GRAY_700 = '#4A5568'
export const COLOR_GREEN = '#83B07C'
export const COLOR_GREEN_NEON = '#88FF0F'
export const COLOR_GRAY_DARK = '#8492A6'
export const COLOR_PINK_CHAMPAGNE = '#FFB8B8'
export const COLOR_PINK_LIGHT = '#D4A181'
export const COLOR_PINK_NEON = '#FE0CD8'
export const COLOR_ORANGE_LIGHT = '#ff5630'
export const COLOR_ORANGE_GRADIENT =
  'linear-gradient(90.07deg, #ED9964 0.06%, #E05D79 99.94%)'
export const COLOR_GREEN_GRADIENT =
  'linear-gradient(90deg, #68B093 0%, #46AD9F 100%)'

/**
 * Fonctionnal colors (ex. Primary, Secondary, Success, Warning etc...)
 */
export const COLOR_ERROR = '#F16063'
export const COLOR_MUTED = COLOR_GRAY__400
export const COLOR_PRIMARY = '#4C6FFF'
export const COLOR_PRIMARY__LIGHT = '#7895FF'
export const COLOR_PRIMARY__DARK = '#3754DB'
export const COLOR_SECONDARY__DARK = '#A6B7D4'
export const COLOR_PRIMARY__TEXT = '#202020'
export const COLOR_WARNING = '#F7936F'

export const RATE_COLOR = '#FFD700'
